

















export default {
  name: 'BillIcon'
}
